<template>
  <Modal v-if="props.memberWithLicence" v-model="showModal" :header="false" data-test="dlm-modal">
    <h2 data-test="dlm-message">
      Are you sure you want to delete ‘{{ memberWithLicence.licensee.firstName }}'s licence?
    </h2>
    <template #footer>
      <div class="controls">
        <button
          class="btn btn-primary"
          @click="toggleLicenceModal"
          data-test="dlm-cancel-btn"
          type="button"
        >
          Cancel
        </button>
        <button
          class="btn btn-default"
          @click="removeLicenceForMember(memberWithLicence.id)"
          data-test="dlm-delete-btn"
          type="button"
        >
          Delete
        </button>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Modal } from "uiv";
import { LicenceApiModel } from "../../../api-models";

const props = defineProps<{ memberWithLicence: LicenceApiModel; showLicenceModal: boolean }>();

const emit = defineEmits(["toggle-licence-modal", "delete-licence"]);

const showModal = computed(() => {
  return props.showLicenceModal;
});

const toggleLicenceModal = (): void => {
  emit("toggle-licence-modal");
};

const removeLicenceForMember = (id: string) => {
  emit("delete-licence", id);
};
</script>

<style scoped lang="less"></style>
